<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="firewalls"
      :items="firewalls"
      :fields="firewallsFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedFirewalls"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      firewallsFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'typeName', label: this.$i18n.t('Type'), sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'comments', label: this.$i18n.t('Comments'), sortable: true},
        {key: 'ip', label: this.$i18n.t('IP'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedFirewalls: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedFirewalls = {
        id: 0,
        name: '',
        comments: '',
        login: '',
        address: '',
        type: 0,
        password: ''
      }
      this.$root.$emit('bv::show::modal', 'modalEditFirewallsSetting', '#btnShow')
    },
    editItem (item) {
      this.selectedFirewalls = item
      this.$root.$emit('bv::show::modal', 'modalEditFirewallsSetting', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Firewalls"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_FIREWALLS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_FIREWALLS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    firewalls () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/FIREWALLS']))
      for (let el of copy) {
        if (el.type === 1) {
          el.typeName = this.$i18n.t('Remote cisco')
        } else {
          el.typeName = this.$i18n.t('Local')
        }
        if (el.address === '0.0.0.0') {
          el.ip = ''
        } else {
          el.ip = el.address
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_FIREWALLS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/firewalls/main.vue